import {
	BrowserClient,
	defaultStackParser,
	getDefaultIntegrations,
	makeFetchTransport,
	httpClientIntegration,
	browserTracingIntegration,
	Scope,
	withScope,
} from '@sentry/react';

const FASTSHIFT_BASE_URL_PROD = 'https://fastshift.atlassian.com';
const FASTSHIFT_BASE_URL_STAGING = 'https://fastshift.stg.internal.atlassian.com';
const FASTSHIFT_BASE_URL_DEV = 'https://fastshift.dev.internal.atlassian.com';

export const FASTSHIFT_BASE_URL =
	process.env['NODE_ENV'] === 'production'
		? FASTSHIFT_BASE_URL_PROD
		: process.env['NODE_ENV'] === 'staging'
			? FASTSHIFT_BASE_URL_STAGING
			: FASTSHIFT_BASE_URL_DEV;

export const FASTSHIFT_STARGATE_BASE_URL = `${FASTSHIFT_BASE_URL}/gateway/api`;

const SENTRY_PROJECT_NAME = 'FASTSHIFT_PORTAL';

const getFastshiftSentryClient = () =>
	new BrowserClient({
		dsn: 'https://01603cd5ba030e96e25a233c4b176e2e@o55978.ingest.us.sentry.io/4510151685242880',
		transport: makeFetchTransport,
		stackParser: defaultStackParser,
		enabled: process.env['CLIENT_LIBRARY_ENV'] !== 'local',
		environment: process.env['CLIENT_LIBRARY_ENV'],
		release: window.BUILD_KEY,
		dist: window.BUILD_KEY,
		integrations: [
			...getDefaultIntegrations({}),
			httpClientIntegration(),
			browserTracingIntegration(),
		],
		tracesSampleRate: 1.0,
		tracePropagationTargets: ['localhost', /^https:\/\/atlassian\.com/],
	});

const getFastshiftSentryScope = () => {
	const scope = new Scope();
	scope.setClient(getFastshiftSentryClient());
	scope.setTag('projectName', SENTRY_PROJECT_NAME);
	return scope;
};

export const sendFastshiftSentryAlert = (
	errorMsg: string,
	httpStatus?: number,
	statusText?: string,
	url?: string,
) => {
	const fastshiftSentryScope = getFastshiftSentryScope();
	withScope(fastshiftSentryScope, () => {
		fastshiftSentryScope.setContext('response', {
			status: httpStatus,
			statusText: statusText,
			url: url,
		});
		fastshiftSentryScope.captureException(new Error(errorMsg));
	});
};
